import { CSSTransition } from 'react-transition-group';
import muteChat from '~/assets/icons/mute_chat.svg';
import { rage, useObservable } from '~/rage';
import { formatTime } from '~/shared';
import { useRemainingTime } from '../../hooks';
import { LineDecor } from '../LineDecor';
import { StyledBanContainer, StyledContainer } from './BanInfo.styled';

const BanInfo = () => {
	const muteExpiresAt = useObservable(rage.restrictions.getMuteExpiresAt());

	const muteRemaining = useRemainingTime(muteExpiresAt);

	return (
		<StyledContainer>
			<CSSTransition
				timeout={500}
				classNames={'ban'}
				in={muteRemaining > 0}
				unmountOnExit
				appear
			>
				<StyledBanContainer>
					<img src={muteChat} />
					<LineDecor $height={30} />
					<p>{formatTime(muteRemaining, '{hh}:{mm}')}</p>
				</StyledBanContainer>
			</CSSTransition>
		</StyledContainer>
	);
};

export { BanInfo };
